import instrumentosImg from '@/assets/help/instrumentos.png';
import type { HelpArticle } from '../types';

export const ASSETS_ARTICLES: HelpArticle[] = [
    {
        slug: 'biblioteca-de-instrumentos',
        topicId: 'assets',
        title: 'Explore a biblioteca de instrumentos',
        description:
            'Escalas e questionários organizados para uso clínico, com busca, visualização e atribuição direta ao paciente.',
        updatedAt: '2026-09-07',
        keywords: ['instrumentos', 'biblioteca', 'escalas', 'buscar', 'atribuir', 'visualizar'],
        blocks: [
            {
                type: 'paragraph',
                text: 'A página **Instrumentos** reúne os recursos avaliativos disponíveis no LaudoPsi: escalas, questionários e materiais técnicos organizados para a elaboração de laudos.',
            },
            {
                type: 'image',
                src: instrumentosImg,
                alt: 'Página Instrumentos de Avaliação Psicológica com a busca e os cards de escalas',
            },
            { type: 'subheading', id: 'buscar', text: 'Encontrando um instrumento' },
            {
                type: 'paragraph',
                text: 'Use a busca por **nome, ID ou palavra-chave**. Dá para encontrar a escala pelo nome popular, como "ASRS", ou pelo tema, como "ansiedade".',
            },
            { type: 'subheading', id: 'acoes', text: 'O que dá para fazer com cada um' },
            {
                type: 'list',
                items: [
                    '**Visualizar**: veja as perguntas e a estrutura do instrumento antes de usar.',
                    '**Atribuir**: envie o instrumento para um paciente responder online, com link seguro de 30 dias.',
                ],
            },
            {
                type: 'callout',
                tone: 'success',
                text: 'Instrumentos respondidos online são corrigidos automaticamente e chegam ao laudo prontos para a sua revisão e aprovação.',
            },
        ],
    },
    {
        slug: 'escolher-o-instrumento-certo',
        topicId: 'assets',
        title: 'Escolha o instrumento certo para cada caso',
        description:
            'Dicas para selecionar escalas pela queixa e pela idade, e como o catálogo de testes apoia as tabelas do laudo.',
        updatedAt: '2026-07-03',
        keywords: ['escolher', 'idade', 'indicação', 'satepsi', 'catálogo', 'escala'],
        blocks: [
            {
                type: 'paragraph',
                text: 'Cada instrumento da biblioteca traz uma descrição curta com a sua indicação, como rastreamento de sintomas depressivos ou avaliação de impulsividade. Antes de enviar, vale conferir três pontos.',
            },
            {
                type: 'list',
                items: [
                    '**A queixa**: a descrição do card resume para que o instrumento serve.',
                    '**A idade do paciente**: escalas de autoavaliação adultas não servem para crianças. Em caso de dúvida, use o Visualizar para ler as perguntas.',
                    '**Quem vai responder**: alguns questionários são para o próprio paciente, outros para pais ou cuidadores.',
                ],
            },
            {
                type: 'subheading',
                id: 'catalogo-laudo',
                text: 'O catálogo de testes dentro do laudo',
            },
            {
                type: 'paragraph',
                text: 'Além dos instrumentos que o paciente responde online, o editor de laudos tem um catálogo com centenas de testes brasileiros para montar tabelas de resultados, com informações como a situação no **SATEPSI** e a faixa etária. Ao escolher um teste do catálogo, a tabela já vem no formato certo.',
            },
            {
                type: 'callout',
                tone: 'info',
                text: 'Aplicou um teste de editora fora do LaudoPsi? Você pode importar o PDF de resultados para o laudo sem redigitar as tabelas. Veja o guia sobre resultados dos testes na seção Laudos.',
            },
        ],
    },
];
